module.exports = __webpack_public_path__ + "img/kata.a925ea62.jpg";